import { render, staticRenderFns } from "./EmployeeDetailsCardWages.vue?vue&type=template&id=6b5595f6&scoped=true&"
import script from "./EmployeeDetailsCardWages.vue?vue&type=script&lang=ts&"
export * from "./EmployeeDetailsCardWages.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeeDetailsCardWages.vue?vue&type=style&index=0&id=6b5595f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5595f6",
  null
  
)

export default component.exports